import { render } from "./LayoutPrincipal.vue?vue&type=template&id=7a7ac6d8&scoped=true"
import script from "./LayoutPrincipal.vue?vue&type=script&lang=js"
export * from "./LayoutPrincipal.vue?vue&type=script&lang=js"

import "./LayoutPrincipal.vue?vue&type=style&index=0&id=7a7ac6d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7ac6d8"]])

export default __exports__